import { Paper, Modal, Box, Chip } from '@mui/material'
import { Typography } from 'antd';
import React, { Component } from 'react'
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { formatDate, formatDateAndTime } from '../../../../Components/CommonFunctions/CommonFunctions';

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const chartFont = "Open Sans";
export default class IPVitalGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      selectedVital: 'weight',
      chipValues: ["Height", "Weight", "BMI", "Temperature"],
      vitalData: this.props.vitaldata ? this.props.vitaldata : [],
      dateList: [],
      weightData: [],
      heightData: [],
      tempData: [],
      selectedChip: "Height",

    }
  }

  componentDidMount() {
    this.processVitalData(this.state.vitalData);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.vitalData !== this.props.vitalData) {
      this.processVitalData(this.props.vitalData);
    }
  }
  // calculateBMI = (weight, height) => {
  //      height = +height / 100;

  //      const bmi = +weight / ((+height) * (+height));

  //     return bmi;
  // }
  calculateBMI = () => {
    return this.state.vitalData.map(item => {
      let height = +item.height_cm / 100;
      if (height > 0) {
        return +(item.weight_kg / (height * height)).toFixed(2); // Round to 2 decimals
      } else {
        return 0;
      }
    });
  };

  processVitalData = (data) => {
    const dateList = data?.map(item => item.vital_entered_time && formatDateAndTime(item.vital_entered_time));
    const weightData = data?.map(item => item.weight_kg);
    const heightData = data?.map(item => item.height_cm);
    const tempData = data?.map(item => item.temperature);
    const BMIData = this.calculateBMI(data);
    this.setState({ dateList, weightData, heightData, tempData, BMIData });
  };
  closePopup = () => {
    this.props.popupClose();
  };
  chartOption = () => {
    return {
      responsive: true,
      maintainAspectRatio: false,
      spanGaps: true,
      plugins: {
        legend: { display: true },
        title: { display: false },
        tooltip: {
          titleFont: { family: chartFont },
          bodyFont: { family: chartFont }
        }
      },
      scales: {
        x: {
          grid: { color: 'rgba(0, 0, 0, 0)', drawBorder: false },
          ticks: {
            align: 'center',
            font: { weight: 'bold', family: chartFont, size: 12 }
          },
          title: {
            display: true,
            text: 'Date',
            color: 'black',
            font: { weight: 'bold', size: 12, family: chartFont }
          }
        },
        y: {
          beginAtZero: false,
          ticks: {
            align: 'center',
            font: { weight: 'bold', family: chartFont }
          },
          title: {
            display: true,
            text: this.state.selectedChip === "Height" ? "Height" : this.state.selectedChip === "Weight" ? "Weight" : this.state.selectedChip === "BMI" ? "BMI" : "Temperature",
            color: 'black',
            font: { weight: 'bold', size: 12, family: chartFont }
          }
        }
      }
    };
  };


  getChartData = () => {
    return {
      labels: this.state.dateList,
      datasets: [
        {
          label: this.state.selectedChip === "Height" ? "Height vs Date" : this.state.selectedChip === "Weight" ? "Weight vs Date" : this.state.selectedChip === "BMI" ? "BMI vs Date" : "Temperature vs Date",
          data: this.state.selectedChip === "Height" ? this.state.heightData : this.state.selectedChip === "Weight" ? this.state.weightData : this.state.selectedChip === "BMI" ? this.state.BMIData : this.state.tempData,
          backgroundColor: "#04B7B1",
          borderColor: "#04B7B1"
        },

      ]
    };
  };
  render() {
    console.log("chartData", this.state.vitalData)
    console.log("selecetedChip", this.state.selectedChip)
    return (
      <Modal open={this.state.open}>
        <Paper elevation={3} id="emedhub_popup_mainBox" sx={{ width: "75vw", height: "84vh", p: 2, backgroundColor: "#fff", borderRadius: 2, display: "flex", flexDirection: "column", gap: 2, }}>
          {/* Title */}
          <div className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
            <Typography style={{ fontSize: "1.2vw", fontWeight: "500" }}>
              Vital graph
            </Typography>
            <div className="eMed_DialogBox_Close">
              <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={this.closePopup} />
            </div>
          </div>
          {/* Chip Row */}
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", }}>
            {this.state.chipValues?.map((item, index) => (
              <Chip
                // className="eMed_chip"
                className={`eMed_chip ${item === this.state.selectedChip ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                size="small"
                label={item}
                // variant="outlined"
                key={index}
                color="primary"
                variant={this.state.selectedChip === item ? 'contained' : "outlined"}
                onClick={() => { this.setState({ selectedChip: item }) }}
                clickable
              />
            ))}
          </Box>

          {/* Graph Area */}
          <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #ddd", borderRadius: 2, p: 2, height: "50vh" }}>
            {/* Replace with actual chart */}
            <Line data={this.getChartData()} options={this.chartOption()} />
          </Box>
        </Paper>
      </Modal>
      // <div style={ {width:"75vw",  height: "90vh" ,border:'2px solid red'}} >IPVitalGraph</div>
    )
  }
}
